import { AxiosInstance } from 'axios';
import { IFileBucketFile } from '../models';

export class FileBucketClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/fileBucket`;
    }

    public async get(idPrefix: string): Promise<IFileBucketFile> {

        const response = await this.axiosClient.get(`${this.apiUrl}/file/${idPrefix}`);

        return response.data;
    }

    public async getMetadata(idPrefix: string): Promise<IFileBucketFile> {

        const response = await this.axiosClient.get(`${this.apiUrl}/file/${idPrefix}/metadata`);

        return response.data;
    }

    public async consolidate(fileName: string): Promise<IFileBucketFile> {

        const response = await this.axiosClient.post(`${this.apiUrl}/consolidate/${encodeURIComponent(fileName)}`);

        return response.data;
    }
}
